<template>
  <v-application v-if="true">
    <v-layout row class="ma-2">
      <v-flex md12>
        <v-combobox
          max-width="200"
          v-model="main_store"
          v-bind:items="stores"
          item-text="name"
          solo
          dense
          prepend-inner-icon="mdi-store"
          return-object
        />
        <v-crud-card
          name="supplier"
          :headers="headers"
          :data="supplier_valuation"
          toSupplier="/inventory/supplier/valuation/data"
          :remove="remove_suppliers"
          :num-pages="suppliers_inv_total"
          v-model="suppliers_inv_page"
          @change-pagination="changePagination"
          :loading_items_table_data="data_loading"
          :add_button_name="'add_supplier'"
          :getData="supplierTransactionsGet"
          no-delete
          @rowClicked="rowClick"
        >
          <template #search>
            <v-spacer />
            <v-btn icon @click="downloadResult">
              <v-icon> mdi-download </v-icon>
            </v-btn>
            <v-dialog v-model="proccesDialog" max-width="400px">
              <v-card>
                <v-list-item-action style="width: 338px; padding-left: 40px">
                  <v-progress-linear
                    :color="
                      excel_dowload_proccess ? 'primary' : 'rgba(0,0,0,0.26)'
                    "
                    background-color="white"
                    height="10"
                    style="border: 1px solid rgba(0, 0, 0, 0.26)"
                    v-bind:value="excel_dowload_proccess"
                    striped
                  />
                  <v-list-item-action-text
                    >{{ $t("download") }}
                    {{ excel_dowload_proccess.toFixed() + " %" }}
                  </v-list-item-action-text>
                </v-list-item-action>
              </v-card>
            </v-dialog>
            <v-slide-x-reverse-transition>
              <v-btn icon @click="searchActivate">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-slide-x-reverse-transition>
            <v-slide-x-reverse-transition>
              <v-text-field
                v-model="search"
                ref="search_field"
                v-if="search_text"
                autofocus
                class="mt-3 pa-0"
                append-icon="mdi-close"
                @click:append="
                  {
                    (search_text = false), (search = ''), getSuppliers();
                  }
                "
                @change="getSuppliers()"
                label="Search"
              ></v-text-field>
            </v-slide-x-reverse-transition>
            <!--<v-btn icon @click="downloadSubTran">-->
            <!--<v-icon>mdi-download</v-icon>-->
            <!--</v-btn>-->
          </template>
        </v-crud-card>
      </v-flex>
    </v-layout>
  </v-application>
  <error404 v-else />
</template>
<script>
import Suppliers from "../../mixins/inventory/supplier";
import SupplierValuation from "../../mixins/inventory/supplier_valuations";
import Services from "../../mixins/services";
// const PageSuppliers = Object.assign(Suppliers, {
//   mounted(){
//     this.update_suppliers()
//   }
// })
import SupplierTransactions from "../../mixins/inventory/supplier_transaction";
import Userable from "../../mixins/userable";
import fileSaver from "file-saver";
import xlsx from "xlsx";

export default {
  name: "SupplierValuation",
  mixins: [
    Suppliers,
    SupplierTransactions,
    Services,
    Userable,
    SupplierValuation,
  ],
  data: () => ({
    access: "",
    search_text: false,
    search: "",
    searchText: "",
    searchService: "",
    main_store: "All stores",
    downExcel: [],
    excel_name: "Suppliervaluation",
    dialog: false,
    wait: true,
    data_loading: false,
    proccesDialog: false,
    excel_dowload_proccess: 0,
    max_total: 0,
  }),
  watch: {
    suppliers_inv_page() {
      this.$store.commit("setsuppValPage", this.suppliers_inv_page);
      this.supplierValuationsGet();
    },
    main_store() {
      this.$store.commit("setItemsService", this.store);
      this.supplierValuationsGet();
    },
  },
  computed: {
    headers() {
      const headers = [
        {
          text: this.$t("supplier_name"),
          value: "supplier_name",
          available: true,
        },
        {
          text: this.$t("inventory_value"),
          value: "inventory",
          available: true,
        },
        {
          text: this.$t("potential_profit"),
          value: "potential",
          available: true,
        },
        { text: this.$t("retail_value"), value: "retail", available: true },
      ];
      return headers;
    },
  },
  methods: {
    rowClick(item) {
      this.$store.state.main_supplier._id = item._id;
      this.$store.state.main_supplier.name = item.supplier_name;
      this.$store.state.main_store = this.main_store;
    },
    changePagination(page) {
      this.suppliers_inv_page = page;
      const query = {
        ...this.$route.query,
        page: this.suppliers_inv_page,
      };
      this.$router.push({ path: this.$route.path, query: query });
      // this.update_suppliers();
    },
    searchActivate() {
      this.search = "";
      this.search_text = true;
    },
    getSuppliers(pageChanged) {
      if (this.searchText === this.search && !pageChanged) {
        return;
      }
      this.supplierValuationsGet();
      this.searchText = this.search;
    },
    async downloadResult() {
      this.proccesDialog = true;
      this.excel_dowload_proccess = 0;
      this.loading = true;
      const limit = 100;
      let all_data = [];
      const page_count = Math.ceil(this.max_total / limit);
      for (let page = 1; page <= page_count; page++) {
        const supplier = this.$communicator.then(
          this,
          await this.$communicator("supplier_valuation", {
            query: {
              limit: limit,
              page: page,
            },
          })
        );
        this.excel_dowload_proccess = (page / page_count) * 100;
        all_data.push(...supplier?.data);
      }
      this.proccesDialog = false;
      this.loading = true;
      const result = await all_data.map((sup) => ({
        supplier_name: sup.supplier_name,
        inventory: Math.round(sup.inventory * 100) / 100,
        potential: Math.round(sup.potential * 100) / 100,
        retail: Math.round(sup.retail * 100) / 100,
      }));
      const ws = xlsx.utils.json_to_sheet(result);
      const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(wb, { bookType: "xlsx", type: "array" });
      const excel_data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
      });
      fileSaver.saveAs(excel_data, "SupplierValuation.xlsx");
    },
    saveExcel() {
      this.dialog = false;
      this.wait = true;
    },
  },
  async mounted() {
    const query = this.$route.query;
    if (query && query.page) {
      this.suppliers_inv_page = parseInt(query.page);
      this.$router.push({ path: this.$route.path, query: query });
    }
    for (const index in this.headers) {
      this.headers[index]["sortable"] = false;
    }
    this.data_loading = true;
    await this.supplierValuationsGet();
    this.data_loading = false;
  },

  beforeMount() {
    this.load_on_mount = false;
    this.suppliers_inv_page = this.$store.state.suppValPage;
    this.main_store = this.$store.state.main_store;
    this.access = this.$store.state.access;
  },
};
</script>
